<template>
  <div class="hide_button" @click="hideButton">
    <pt-icon type="icon-guanbi"></pt-icon>
  </div>

</template>

<script>
  export default {
    name: 'closeTag',
    methods:{
      hideButton(){
        this.$emit('hideButton')
      }
    }
  }
</script>

<style scoped lang="less">
  .hide_button {
    cursor: pointer;
    width: 24px;
    height: 24px;
    background: #BCBCBC;
    float: right;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>